import React, { Component } from 'react';
import { placeholderReplace } from 'src/services/string-helper';
// images
const bagsOversize = require('../../images/bags-oversize.svg');

interface IProps {
  trackingData: any;
  statusHandler: any;
  statementContent: any;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
  step: number;
}

export class ExcessOverweightOversizeBags extends Component<IProps> {

  render() {
    const { language, multiLang, step } = this.props;
    const displayMessage = this.props.trackingData.preAcceptance.excessBagCharge.statementContent.translation ? this.props.trackingData.preAcceptance.excessBagCharge.statementContent.translation.message : this.props.trackingData.preAcceptance.excessBagCharge.statementContent.message ? this.props.trackingData.preAcceptance.excessBagCharge.statementContent.message : '';
    const parameters = this.props.trackingData.preAcceptance.excessBagCharge.statementContent.translation ? this.props.trackingData.preAcceptance.excessBagCharge.statementContent.translation.parameters : {};

    return (
      <>
        <div className='preStep'>
          <img src={bagsOversize} style={{ marginTop: '32px' }} alt='bags Oversize' />
          <div className='preStep__title'>
            <h2>{multiLang[`excessTitle${language}`]}</h2>
          </div>
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`excessPanelTitle${language}`]}</h2>
            </div>
            <div className='preStep__body'>
              <p>{multiLang[`excessPanelText1${language}`]}</p>
              <div className='grayBox'>
                <p dangerouslySetInnerHTML={{ __html: placeholderReplace(multiLang[`${displayMessage}${language}`], parameters) }}></p>
              </div>

              <div className='preStep__footer'>
                <button className='btn btn__purple' onClick={() => this.props.statusHandler(step + 1)}>{multiLang[`excessButton${language}`]}</button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ExcessOverweightOversizeBags;



// WEBPACK FOOTER //
// ./src/components/excess-overweight-oversize-bags/excess-overweight-oversize-bags.tsx